<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useScript } from '@unhead/vue'

interface CustomWindow {
  instgrm?: { Embeds: { process: () => void } };
}

declare let window: CustomWindow

const props = defineProps<{
  html: string
}>()

const instagramEmbedScript = useScript({
  key: 'instagram-embed-script',
  src: '//www.instagram.com/embed.js',
  async: true
})

const triggerEmbedScript = () => {
  if (typeof window !== 'undefined' && window.instgrm) {
    window.instgrm.Embeds.process()
  }
}

onMounted(async () => {
  await instagramEmbedScript.$script.load()
  triggerEmbedScript()
})

watch(() => props.html, async () => {
  // Ensure the script is loaded before trying to process embeds,
  // .load() is idempotent and will resolve immediately if already loaded.
  await instagramEmbedScript.$script.load()
  triggerEmbedScript()
})
</script>

<template>
  <div v-html="props.html" />
</template>
